import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Lock, CreditCard, Clock, Star } from 'lucide-react';
export function PricingSection() {
  const [selectedPlan, setSelectedPlan] = useState<'standard' | 'elite'>('elite');
  const plans = {
    standard: {
      id: 'standard',
      name: 'FUNCIONAL & CROSS 360',
      emoji: '📘',
      description: '6 Tomos + 6 Bonos',
      originalPrice: '$34.990',
      price: '$19.990',
      url: 'https://checkout.rincondigital.shop/cart/54042948501779:1'
    },
    elite: {
      id: 'elite',
      name: 'PACK COMPLETO',
      emoji: '🏆',
      description: '6 Tomos + 6 Bonos + Elite Coach 360™',
      originalPrice: '$43.990',
      price: '$27.990',
      url: 'https://checkout.rincondigital.shop/cart/54043001291027:1',
      badges: [{
        text: 'MÁS ELEGIDO',
        icon: <Star className="w-3 h-3 fill-current" data-id="element-275" />,
        bg: 'bg-lime-500',
        textCol: 'text-dark-900'
      }, {
        text: 'AHORRÁS $16.000',
        bg: 'bg-lime-500/10',
        textCol: 'text-lime-500',
        border: 'border-lime-500/30'
      }]
    }
  };
  const currentPlan = plans[selectedPlan];
  return <Section id="pricing" bg="dark-900" data-id="element-276">
      <div className="max-w-3xl mx-auto" data-id="element-277">
        <div className="text-center mb-8 md:mb-12" data-id="element-278">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-3 md:mb-4" data-id="element-279">
            Elegí tu Funcional & Cross 360:
          </h2>
          <p className="text-lg md:text-xl text-lime-400 font-medium" data-id="element-280">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        <div className="space-y-4 md:space-y-6 mb-8" data-id="element-281">
          {/* Standard Plan */}
          <div onClick={() => setSelectedPlan('standard')} className={`relative cursor-pointer rounded-2xl p-5 md:p-8 transition-all duration-300 border-2 flex items-center gap-4 md:gap-6 ${selectedPlan === 'standard' ? 'bg-dark-800 border-lime-500 shadow-[0_0_30px_rgba(204,255,0,0.1)]' : 'bg-dark-800/50 border-dark-700 hover:border-dark-600'}`} data-id="element-282">
            {/* Radio Circle */}
            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${selectedPlan === 'standard' ? 'border-lime-500' : 'border-gray-500'}`} data-id="element-283">
              {selectedPlan === 'standard' && <div className="w-3 h-3 rounded-full bg-lime-500" data-id="element-284" />}
            </div>

            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-285">
              <div data-id="element-286">
                <div className="flex items-center gap-2 mb-1" data-id="element-287">
                  <span className="text-xl md:text-2xl" data-id="element-288">
                    {plans.standard.emoji}
                  </span>
                  <h3 className="text-lg md:text-xl font-display font-bold text-white" data-id="element-289">
                    {plans.standard.name}
                  </h3>
                </div>
                <p className="text-sm md:text-base text-gray-400" data-id="element-290">
                  {plans.standard.description}
                </p>
              </div>

              <div className="text-left md:text-right" data-id="element-291">
                <div className="text-gray-500 line-through text-sm md:text-base font-display font-bold mb-0.5" data-id="element-292">
                  {plans.standard.originalPrice}
                </div>
                <div className="text-3xl md:text-4xl font-display font-bold text-white" data-id="element-293">
                  {plans.standard.price}
                </div>
              </div>
            </div>
          </div>

          {/* Elite Plan */}
          <div onClick={() => setSelectedPlan('elite')} className={`relative cursor-pointer rounded-2xl p-5 md:p-8 transition-all duration-300 border-2 flex items-center gap-4 md:gap-6 ${selectedPlan === 'elite' ? 'bg-dark-800 border-lime-500 shadow-[0_0_30px_rgba(204,255,0,0.15)]' : 'bg-dark-800/50 border-dark-700 hover:border-dark-600'}`} data-id="element-294">
            {/* Radio Circle */}
            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${selectedPlan === 'elite' ? 'border-lime-500' : 'border-gray-500'}`} data-id="element-295">
              {selectedPlan === 'elite' && <div className="w-3 h-3 rounded-full bg-lime-500" data-id="element-296" />}
            </div>

            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-297">
              <div data-id="element-298">
                <div className="flex items-center gap-2 mb-2" data-id="element-299">
                  <span className="text-xl md:text-2xl" data-id="element-300">
                    {plans.elite.emoji}
                  </span>
                  <h3 className="text-lg md:text-xl font-display font-bold text-white" data-id="element-301">
                    {'Elite Coach 360'}
                  </h3>
                </div>

                <div className="flex flex-wrap items-center gap-2 mb-2" data-id="element-302">
                  {plans.elite.badges?.map((badge, i) => <span key={i} className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] md:text-xs font-bold tracking-wider ${badge.bg} ${badge.textCol} ${badge.border ? `border ${badge.border}` : ''}`} data-id="element-303">
                      {badge.icon}
                      {badge.text}
                    </span>)}
                </div>

                <p className="text-sm md:text-base text-gray-400" data-id="element-304">
                  {plans.elite.description}
                </p>
              </div>

              <div className="text-left md:text-right" data-id="element-305">
                <div className="text-gray-500 line-through text-sm md:text-base font-display font-bold mb-0.5" data-id="element-306">
                  {plans.elite.originalPrice}
                </div>
                <div className="text-3xl md:text-4xl font-display font-bold text-lime-400" data-id="element-307">
                  {plans.elite.price}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center" data-id="element-308">
          <Button href={currentPlan.url} variant="primary" size="xl" fullWidth className="mb-4 shadow-[0_0_40px_rgba(204,255,0,0.2)]" data-id="element-309">
            {selectedPlan === 'elite' ? 'SÍ, QUIERO PACK COMPLETO' : 'SÍ, QUIERO MI PACK AHORA'}
          </Button>

          <p className="text-gray-400 italic text-sm md:text-base mb-8 text-center" data-id="element-310">
            La opción más elegida por profes que enseñan en todos los niveles
          </p>

          <div className="w-full max-w-2xl border border-dark-700 bg-dark-800/50 rounded-xl p-4 flex flex-wrap justify-center items-center gap-4 md:gap-8 text-xs md:text-sm text-gray-300 font-medium" data-id="element-311">
            <div className="flex items-center gap-2" data-id="element-312">
              <Lock className="w-4 h-4 text-lime-500" data-id="element-313" />
              <span data-id="element-314">Pago seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-315">
              <Clock className="w-4 h-4 text-lime-500" data-id="element-316" />
              <span data-id="element-317">Acceso en 5 min</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-318">
              <ShieldCheck className="w-4 h-4 text-lime-500" data-id="element-319" />
              <span data-id="element-320">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-321">
              <CreditCard className="w-4 h-4 text-lime-500" data-id="element-322" />
              <span data-id="element-323">Mercado Pago</span>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}